import gql from "graphql-tag";

const gqlQuery = gql`
  query Customer($customerId: ID) {
    customer(customerId: $customerId) {
      id
      description
      contracts {
        id
        name
      }
      users {
        username
      }
    }
  }
`;

export default customerId => ({
  query: gqlQuery,
  skip: !customerId,
  variables: { customerId },
});
